import { useState } from 'react';
import { LoadingMessageEnum as LoadingMessage } from '../helpers/LoadingMessageEnum';

export const useLoadingMessage = () => {
    const [loadingMessage, setLoadingMessage] = useState<string>(LoadingMessage.Message);
    return { loadingMessage, setLoadingMessage };
};